import { useSelectorApp } from "../../../lib/redux";

const useCheckAnonymous = () => {
  const { user } = useSelectorApp((state) => state.auth);
  const isAnonymous = user?.isAnonymous;

  const checkIsAnonymous = () => {
    if (isAnonymous) {
      const button = document.getElementById(
        "button-create-account-from-anonymous"
      );
      if (button) {
        button.click();
      }
      return true;
    }
    return false;
  };

  return { checkIsAnonymous };
};

export default useCheckAnonymous;
